import { useRouter } from "next/navigation";
import Modal from "./Modal";

interface LocationLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUseDefault: () => void;
  description?: string;
  /** Optional secondary helper line (e.g. guest nearest-sort helper). */
  helperText?: string;
}

export default function LocationLoginModal({
  isOpen,
  onClose,
  onUseDefault,
  description = "To show you items near your location, you need to be logged in.",
  helperText,
}: LocationLoginModalProps) {
  const router = useRouter();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Location-Based Items"
      maxWidth="md"
      renderAction={true}
      onConfirm={() => {
        onClose();
        router.push("/login");
      }}
      onCancel={() => {
        onClose();
        onUseDefault();
      }}
      confirmText="Login/Signup"
      cancelText="Use Default Location (Ikeja)"
    >
      <div className="space-y-4">
        <p className="text-text-light">{description}</p>
        {helperText ? (
          <p className="text-sm font-medium text-foreground">{helperText}</p>
        ) : null}
      </div>
    </Modal>
  );
}
